
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.182 0H.817L15 11.819 29.182 0z"}}),_c('path',{attrs:{"d":"M15.384 13.062a.599.599 0 01-.768 0L0 .88V19.8a.6.6 0 00.6.6h28.8a.6.6 0 00.6-.6V.88L15.384 13.06z"}})])
          )
        }
      }
    